import { useMutation } from '@tanstack/react-query';
import { POST, POST_INSERT_MANAGEMENT_DATE } from '../../../../services';
import { InsertManagementData } from '../../../../resources/payload';
import { openAlert } from '../../../../components/alert/hooks';

export const useInsertManageData = () => {
  return useMutation({
    mutationFn: async (values) => {
      const payload = InsertManagementData(values);
      const response = await POST(POST_INSERT_MANAGEMENT_DATE(), payload);

      return response.result;
    },
    onSuccess: () => {
      openAlert({
        model: 'message',
        type: 'success',
        message: 'เพิ่ม Management สำเร็จ',
      });
      setTimeout(() => {
        window.location.reload();
      }, 500);
    },
  });
};
